import {Component, OnInit} from '@angular/core';
import {LocalStorageService} from '../share/localstorage.service';
import {UserSettingItem} from './user.module';
import { HttpClient, HttpParams } from '@angular/common/http';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DialogComponent} from '../dialog/dialog.component';
import {SyncService} from '../share/sync.service';
import {IDBPDatabase, openDB} from 'idb';

@Component({
    selector: 'app-user',
    templateUrl: 'user.component.html',
    styleUrls: ['user.component.css'],
    standalone: false
})
export class UserComponent implements OnInit {
    public Ueberschrift: string = this.ls.get('APP_Ueberschrift');
    private User_Key: string = this.ls.get('User_Key');

    public settings: UserSettingItem[] = [];
    public status_change;
    public temp_status: string;
    private db: IDBPDatabase;


    public device_type: string = '';
    public device_view: string = '';

    DialogRef: MatDialogRef<DialogComponent>;

    constructor(private http: HttpClient, private ls: LocalStorageService,
                private SyncService: SyncService, private dialog: MatDialog) {
    }


    ngOnInit() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.device_type = 'Mobile - ' + navigator.userAgent;
        } else {
            this.device_type = 'NO Mobile - ' + navigator.userAgent;
        }
        if (window.matchMedia('(display-mode: fullscreen)').matches) {
            this.device_view = 'fullscreen'
        }
        ;
        if (window.matchMedia('(display-mode: standalone)').matches) {
            this.device_view = 'standalone'
        }
        ;
        if (window.matchMedia('(display-mode: minimal-ui)').matches) {
            this.device_view = 'minimal-ui'
        }
        ;
        if (window.matchMedia('(display-mode: browser)').matches) {
            this.device_view = 'browser'
        }
        ;


        this.getdata();
        this.status_change = 0;
    }


    async open_db() {       // Prüft ob die DB vorhanden ist, legt diese sonst an!
        this.db = await openDB('fapp-store', 1, {});
    }

    onchange(id, val) {

        this.open_db().then(()=> this.db.clear('pocsag'));

        const params = new HttpParams()
            .set('MachineId', String(localStorage.getItem('MachineId')))
            .set('AuthentificationKey', String(localStorage.getItem('AuthentificationKey')))
            .set('action', 'save')
            .set('id', id)
            .set('value', val)
            .set('random', Math.random().toString());


        this.http.get('https://fappback.devhm.de/settings_save.php', {params})
            .subscribe(() => {
                this.SyncService.GetDataFromWeb('initial'); //initial damit auch die neuen Daten gankkommen
                //location.reload(true);
            });
    }


    onaction(id, action) {
        alert("STOPPPP");
        if (action === 'testpushover') {
            const params = new HttpParams()
                .set('key', this.User_Key)
                .set('random', Math.random().toString());

            this.http.get('https://apps.elw-trave-land.de/services/test_pushover.php', {params})
                .subscribe(() => {

                });
            this.DialogRef = this.dialog.open(DialogComponent, {
                data: {titel: 'Hinweis', text: 'Der Pushover Test-Alarm ist versendet!'}
            });
        }


    }

    opendialog(setting) {
        this.DialogRef = this.dialog.open(DialogComponent, {
            data: {titel: 'Hinweis', text: setting.beschreibung}
        });
    }


    toggle(set) {
        if (set.anzeigen === 'true') {
            set.anzeigen = 'false';
        } else {
            set.anzeigen = 'true';
        }
    }


    getdata() {
        this.SyncService.sync('');
        this.settings = this.SyncService.getUserSettings();


    }



}
